var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgModalclose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E7EC",
  fillRule: "evenodd",
  d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#535861",
  d: "M16.347 7.805a.53.53 0 0 1-.005.752l-3.485 3.44 3.485 3.44a.532.532 0 0 1-.747.757l-3.495-3.45-3.494 3.45a.532.532 0 0 1-.748-.757l3.485-3.44-3.485-3.44a.532.532 0 1 1 .748-.757l3.494 3.45 3.495-3.45a.53.53 0 0 1 .752.005"
})));
export default SvgModalclose;